<template>
  <layout-admin-dashboard-view :show-title-back-link="false">
    <template #title>
      {{ translateTitleCase("admin.dashboard.dashboardTitle") }}
    </template>

    <template #mainContent>
      <card>
        <div class="text-center">
          <h1 class="h2 margin-l-bottom">
            {{tu('admin.dashboard.welcomeTitle')}}
          </h1>
          <p class="text-xl margin-remove">
            {{tu('admin.dashboard.welcomeExplain')}}
          </p>
        </div>
      </card>
    </template>
  </layout-admin-dashboard-view>
</template>

<script>
import { useMeta } from "vue-meta";
import { useI18n } from "vue-i18n";

export default {
  name: "AdminDashboardViewLegacy",
  setup() {
    let { t } = useI18n();
    let { meta } = useMeta({
      title: t("admin.dashboard.title"),
    });
    //meta.sitename.content = 'Saffron Admin';

    return { meta };
  },
  data: function () {
    return {
      links: [
        {
          to: { name: "admin-vendor" },
          icon: "cart",
          shortLabel: "admin.vendors.shortLabel",
          label: "admin.vendors.label",
          description: "admin.vendors.description",
        },
        {
          to: { name: "admin-entity" },
          icon: "copy",
          shortLabel: "admin.entity.titleShort",
          label: "admin.entity.title",
          description: "admin.entity.description",
        },

        {
          to: { name: "admin-user" },
          icon: "user",
          shortLabel: "admin.user.titleShort",
          label: "admin.user.title",
          description: "admin.user.description",
        },
        {
          to: { name: "admin-language" },
          icon: "chat",
          shortLabel: "admin.language.titleShort",
          label: "admin.language.title",
          description: "admin.language.description",
        },
      ],
    };
  },
  created() {

  },
};
</script>

<style scoped lang="scss">
.admin-item-link {
  cursor: pointer;

  .uk-card-title {
    display: flex;
    align-items: center;
    justify-content: flex-start;

    .uk-icon {
      position: relative;
      margin-right: 4px;
      // top: 0px;
    }
  }
}
</style>
